import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  VERSION,
  Input,
  Inject,
} from "@angular/core";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
} from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Comentario } from "src/app/shared/model/tickets/comentario.model";
import swal from "sweetalert2";
import { AuthService } from "src/app/security/auth.service";
import { Tickets } from "src/app/shared/model/tickets/tickets.model";

import { MensajesFijosEnum } from "src/app/utilerias/enums/mensajes-fijos-enum";
import { SweetAlertComponent } from "src/app/shared/SweetMesssage";
import { TicketsEstatus } from "src/app/utilerias/enums/tickets-estatus.enum";
import { TicketsService } from "src/app/tickets/tickets.service";
import { ToastrService } from "ngx-toastr";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import {
  MatFormField,
  MatLabel,
  MatInput,
  MatError,
} from "@angular/material/input";
import { NgIf, NgFor } from "@angular/common";
import { MatSelectionList, MatListOption } from "@angular/material/list";

@Component({
  selector: "app-modal-tickets",
  standalone: true,
  templateUrl: "./modal-tickets.component.html",
  styleUrls: ["./modal-tickets.component.css"],
  imports: [
    MatIconButton,
    MatIcon,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    NgIf,
    MatError,
    MatSelectionList,
    NgFor,
    MatListOption,
    MatDialogActions,
    MatButton,
  ],
})
export class ModalTicketsComponent implements OnInit {
  dialogRef: MatDialogRef<any>;
  version = VERSION.full;

  dateNow: Date = new Date();
  fechaActual: Date;

  datos: any;

  @ViewChild("inputDescripcionCtrl") inputDescripcionCtrl: ElementRef;

  totalsize = 0;
  evidencia = [];
  selectedOptions = [];
  index: number;
  btnElimina: boolean = true;

  selectedFile: File;
  comentario: Comentario;
  //evidencia = new Evidencia();
  options: FormGroup;
  cambioEstatus: boolean;
  cambioDeEstatusACancelado: boolean;
  cambioDeEstatusAReabierto: boolean;
  mostrarHoras: boolean;
  adondeVaAredireccionar: string;
  datosTicket: Tickets;
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  showDatosComplementarios: boolean;
  bandera: boolean = false;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    public modal: MatDialogRef<ModalTicketsComponent>,
    private ticketsService: TicketsService,
    private authS: AuthService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private mensaje: SweetAlertComponent
  ) { }

  private imagen;

  ngOnInit() {
    this.comentario = new Comentario();
    this.datosTicket = Object.assign({}, this.data.datos); // estructura para Clonar un objeto
    this.cambioEstatus = this.data.cambioEstatus;
    this.cambioDeEstatusACancelado = this.data.cambioDeEstatusCancelado;
    this.cambioDeEstatusAReabierto = this.data.cambioDeEstatusReabierto;
    this.adondeVaAredireccionar = this.data.redireccionamiento;
    this.mostrarHoras = this.data.mostrarHoras;
    if (
      this.data.showDatosComplementarios != null &&
      this.data.showDatosComplementarios != undefined
    ) {
      this.showDatosComplementarios = this.data.showDatosComplementarios;
    } else {
      this.showDatosComplementarios = false;
    }
    this.datosTicket.causaOrigenProblema = "NA";
    this.datosTicket.paliativo = "NA";
    this.datosTicket.solucionDefinitiva = "NA";
    this.datosTicket.impacto = "NA";

    if (this.mostrarHoras && this.showDatosComplementarios) {
      this.options = this.fb.group({
        descripcionCtrl: ["", Validators.required],
        causaProblemaCtrl: [""],
        paliativoCtrl: [""],
        solucionCtrl: [""],
        impactoCtrl: [""],
        horasCtrl: [""],
        minutosCtrl: [""],
      });
    } else if (this.mostrarHoras) {
      this.options = this.fb.group({
        descripcionCtrl: ["", Validators.required],
        causaProblemaCtrl: [""],
        paliativoCtrl: [""],
        solucionCtrl: [""],
        impactoCtrl: [""],
        horasCtrl: [""],
        minutosCtrl: [""],
      });
    } else {
      this.options = this.fb.group({
        descripcionCtrl: ["", Validators.required],
        horasCtrl: [""],
        minutosCtrl: [""],
        causaProblemaCtrl: [""],
        paliativoCtrl: [""],
        solucionCtrl: [""],
        impactoCtrl: [""],
      });
    }

    this.llenarDatos();
  }
  onUpload(e) { }

  salir() {
    this.modal.close();
  }

  limpiar(): void {
    if (this.inputDescripcionCtrl) {
      this.options.reset();
      this.inputDescripcionCtrl.nativeElement.focus();
    }
  }

  guardarEstatus(bandera): void {
    this.fechaActual = this.dateNow;
    // this.fechaActual = this.formatFecha(
    //   this.fechaActual
    // );
    if (this.cambioEstatus && this.cambioEstatus != undefined) {
      let status: TicketsEstatus;

      if (this.datosTicket.id_estatus != 6) {
        status = this.retornarEstatus(Number(this.datosTicket.id_estatus) + 1);
      } else {
        status = TicketsEstatus.PROCESO;
      }
      this.datosTicket.id_estatus = status;
      this.comentario.id_estatus = this.datosTicket.id_estatus;
    } else if (
      this.cambioDeEstatusACancelado &&
      this.cambioDeEstatusACancelado != undefined
    ) {
      this.datosTicket.id_estatus = TicketsEstatus.CANCELADA;
      this.comentario.id_estatus = this.datosTicket.id_estatus;
    } else if (
      this.cambioDeEstatusAReabierto &&
      this.cambioDeEstatusAReabierto != undefined
    ) {
      this.datosTicket.id_estatus = TicketsEstatus.REABIERTA;
      this.comentario.id_estatus = this.datosTicket.id_estatus;
    }
    this.ticketsService
      .editarEstatusDeTicket(this.datosTicket)
      .subscribe((res) => {
        if (res != null) {
          this.comentario.fecha = this.fechaActual;
          this.guardarComentario(bandera);
        } else {
          this.toastr.error(
            " No se pudo editar el estatus del ticket. ",
            "  ",
            {
              timeOut: 3000,
              closeButton: true,
              positionClass: "toast-" + "bottom" + "-" + "center",
            }
          );
        }
      });
  }
  guardarComentario(bandera) {
    this.ticketsService.guardarComentario(this.comentario).subscribe((res) => {
      if (res != null) {
        for (let i = 0; i < this.evidencia.length; i++) {
          const formData = new FormData();
          formData.append(
            "file",
            this.evidencia[i],
            "$" + res.id + "$" + this.evidencia[i].name
          );
          this.ticketsService.uploadEvidencia(formData).subscribe();
        }
        this.toastr
          .info(" Se agregó comentario! ", "  ", {
            timeOut: 3000,
            closeButton: true,
            positionClass: "toast-" + "bottom" + "-" + "center",
          })
          .onHidden.subscribe(() => {
            const datos = {
              comentario: this.comentario,
              cancelado: bandera,
            };
            this.modal.close(datos);
          });
      } else {
        this.toastr.error(" No se pudo agregar comentario. ", "  ", {
          timeOut: 3000,
          closeButton: true,
          positionClass: "toast-" + "bottom" + "-" + "center",
        });
      }
    });
  }

  regresar() {
    this.router.navigate(["TICKETS" + this.adondeVaAredireccionar]);
  }

  llenarDatos() {
    this.authS.getSesion().subscribe((res) => {
      this.comentario.id_usuario = res.usuario.id;
      this.comentario.id_estatus = this.data.datos.id_estatus;
      this.comentario.id_ticket = this.data.datos.id_ticket;
    });
  }

  formatFecha(str: any): any {
    const date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);

    //return [date.getFullYear(), mnth, day].join('-');
    return new Date(str);
  }

  cancelar(): void {
    this.dialogRef.close();
  }

  /*Obtiene la imagen y descripcion*/
  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => this.generaBitImagen(e);
    reader.readAsDataURL(this.selectedFile);
  }

  /* consulta el detalle de la imagen para obtenerla en base64 */
  generaBitImagen(f: any) {
    const image: string = f.target.result;
    if (image != undefined && image != null) {
      const cadenaArray = image.split(",");
      this.imagen = cadenaArray[1];
      this.guardarImagen();
    }
  }

  guardarImagen() {
    //this.generarDocumentoredito();
    this.ticketsService.guardarImagen(/*this.evidencia*/).subscribe((res) => {
      if (res != null && res != undefined) {
        if (this.validarCodigoRetorno(res.pCodRetorno)) {
          /*this.map.set(this.descripcion, [res.idArchivo, res.id]);
          this.btnNextDisabled = (this.map.size ==3) ? false : true;

          this.msg.succTime(null,'Imágen guardada correctamente');*/
        } else {
          this.mensaje.showSwal(
            "info-rule",
            res.pMensaje !== null && res.pMensaje !== undefined
              ? res.pMensaje
              : MensajesFijosEnum.ERROR_SERVIDOR
          );
        }
      } else {
        this.mensaje.showSwal(
          "error-message",
          MensajesFijosEnum.ERROR_SERVIDOR
        );
      }
    });
  }

  validarCodigoRetorno(codigo: string): boolean {
    if (this.convertirANumbero(codigo) === 0) {
      return true;
    }
    return false;
  }

  convertirANumbero(numero: any): number {
    if (numero != null && numero !== undefined) {
      try {
        return Number(numero);
      } catch (e) {
        return -1;
      }
    } else {
      return -1;
    }
  }

  //subir evidencia
  subirEv() {
    const input = <HTMLInputElement>document.getElementById("nameFile");
    if (input.files.length > 0) {
      for (let i = 0; i <= input.files.length - 1; i++) {
        this.totalsize = this.totalsize + input.files.item(i).size;
        this.evidencia.push(input.files[i]);
      }
    }
    (<HTMLInputElement>document.getElementById("nameFile")).value = "";
  }

  onNgModelChange($event) {
    if ($event.length != 0) {
      this.btnElimina = false;
    } else {
      this.btnElimina = true;
    }
  }

  elimina() {
    for (let i = 0; i < this.selectedOptions.length; ++i) {
      this.index = this.evidencia.findIndex(
        (item) => item.name == this.selectedOptions[i].name
      );
      this.evidencia.splice(this.index, 1);
    }
    (<HTMLInputElement>document.getElementById("nameFile")).value = "";
  }

  retornarEstatus(numero: number): TicketsEstatus {
    switch (numero) {
      case TicketsEstatus.ABIERTA:
        return TicketsEstatus.ABIERTA;
      case TicketsEstatus.PROCESO:
        return TicketsEstatus.PROCESO;
      case TicketsEstatus.ATENDIDA:
        return TicketsEstatus.ATENDIDA;
      case TicketsEstatus.VOBO:
        return TicketsEstatus.VOBO;
      case TicketsEstatus.CANCELADA:
      default:
        return null;
    }
  }

  guardar() {
    if (
      this.datosTicket.id_estatus == 3 ||
      (this.cambioDeEstatusACancelado &&
        this.cambioDeEstatusACancelado != undefined)
    ) {
      this.bandera = true;
      swal
        .fire({
          title: "¿Estás seguro?",
          text: "Este cambio de estatus no se podrá revertir",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3f9142",
          cancelButtonColor: "#f44336",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",

        })
        .then((result) => {
          if (result.value) {
            this.guardarEstatus(this.bandera);
          }
        });
    } else this.guardarEstatus(this.bandera);
  }
}
